module.exports = __webpack_public_path__ + "51bab1cd6baf308461ee2ff2bcf2c669.MP3";